// extracted by mini-css-extract-plugin
module.exports = {"temporaryOfferBanner":"temporary-offer-banner-wrapper_temporaryOfferBanner__wsvUS"};